import React, { useEffect } from 'react';

const ExecutiveSummaryAI = () => {
	useEffect(() => {
		window.open('https://airx.ocinsights.ai/', '_blank');
	}, []);

	return null;
};

export default ExecutiveSummaryAI;
